// extracted by mini-css-extract-plugin
module.exports = {"main":"_2haVk7rV","right":"_2WdH0LbQ","left":"_2s9uqgHF","block":"rbSTCP_v","templates":"_1_Rd866p","saveButton":"_3ah1Qm_h","savedButton":"_1frWWgcN","delete":"_1hmH-48r","edit":"_3sb6MEoP","template":"_3eCNPC2C","selectedTemplateContainer":"EOtHktMs","selectedTemplate":"uUitlgYO","empty":"_3f7Stn3F","buttons":"_1RHdMx25"};
    if(module.hot) {
      // 1746735812126
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  